<template>
  <faq-standalone-main :slug="slug" :url="url" />
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class FaqStandalonePage extends Vue {
  get slug() {
    return this.$route.params.slug
  }

  get url() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: Type $config properly
    return `https://${this.$config.public.envUrl}${this.$route.path}`
  }
}

export default toNative(FaqStandalonePage)
</script>
